import { Instance } from 'mobx-state-tree';
import { GroupStore } from '../../../store';
import { inject, observer } from 'mobx-react';
import React from 'react';

import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { Group } from '../../../store/models/Group';
import MultiSelectInputFormField from './MultiSelectInputFormField';

interface GroupsFormFieldProps extends WithTranslateProps {
  GroupStore?: Instance<typeof GroupStore>;
  groupList?: Array<Instance<typeof Group>>;
  onGroupIdChanged?: (groupId: number | undefined) => void;
  groupId?: number | undefined;
}

@inject('GroupStore')
@observer
class GroupsFormField extends React.Component<GroupsFormFieldProps> {
  renderGroupMenuItem(item: Instance<typeof Group>, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem
          key={`group-${index}`}
          active={modifiers.active}
          onClick={handleClick}
          text={item.name + ' - ' + item.description!}
        />
      );
    } else {
      return null;
    }
  }

  filterGroup = (query, group) => {
    return (group.name + ' - ' + group.description!).toLowerCase().indexOf(query.toLowerCase()) >= 0;
  };

  render() {
    const { GroupStore, groupId, ...otherProps } = this.props;
    let { groupList } = this.props;
    if (groupList == null) {
      groupList = GroupStore!.dataList;
    }

    // Si groupId est une valeur unique, la transformer en tableau
    const selectedGroupIds = Array.isArray(groupId) ? groupId : groupId ? [groupId] : [];

    return (
      <>
        <MultiSelectInputFormField<Instance<typeof Group>, number>
            label={TLCode.PHARMACIES_Groups}
            name="groupId"
            inline={true}
            items={toJS(groupList)}
            itemValueGetter={(item) => (item as Instance<typeof Group>).groupId}
            valueItemGetter={(value) => GroupStore!.getById(value)!}
            inputValueRenderer={(item) => (item != null ? item.name + ' - ' + item.description! : '')}
            itemRenderer={this.renderGroupMenuItem}
            tagRenderer={(item) => (item as Instance<typeof Group>).name}
            itemPredicate={this.filterGroup}
            identifier="groupId"
            elementLabel="name"
            labelSelectAnElement={this.props.translate(TLCode.CHOOSE_A_GROUP)}
            placeholderSelection={TLCode.CHOOSE_A_GROUP}
            value={selectedGroupIds}
            afterItemSelected={this.props.onGroupIdChanged}
            {...otherProps}
            />
      </>
    );
  }
}

export default withTranslate(GroupsFormField);
